import React from 'react'
import './App.css'
import { Routes,Route } from 'react-router-dom'
import Home from './components/Home'
import About from './components/About'
import Courses from './components/Courses'
import Contact from './components/Contact'
import Register from './components/Register'
import Login from './components/Login'
import PageNotFound from './components/PageNotFound'
import Admin from './components/Admin'
import Table from './components/Table'
import Register2 from './components/Register2'
import Parent from './components/Parent'
import Services from './components/Services'
import WebDesign from './components/WebDesign'
import WebDev from './components/WebDev'
import Digital from './components/Digital'
import Cart from './components/Cart'


const Dashboard = React.lazy(()=>import('./components/Dashboard'))

const App = () => {
  return (
    <>
      <Routes>
        <Route path='' element={<Home />} />
        <Route path='/home' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/courses' element={<Courses />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/register' element={<Register />} />
        <Route path='/login' element={<Login />} />
        <Route path='/admin' element={<Admin />} />
        <Route path='/table' element={<Table />} />
        <Route path='/register2' element={<Register2 />} />
        <Route path='/dashboard' element={<Dashboard />} />
        <Route path='/parent' element={<Parent />} />
        <Route path='/cart' element={<Cart />} />
        
        <Route path='/services' element={<Services />}>
          <Route path='' element={<WebDesign />} />
          <Route path='webdesign' element={<WebDesign />} />
          <Route path='webdev' element={<WebDev />} />
          <Route path='digital' element={<Digital />} />

        </Route>

        <Route path='*' element={<PageNotFound />} />
      </Routes>
        
        
    </>
  )
}

export default App
